const serverEndpoint = '/admin/update';
let editInputs;

window.onload = function() {
    initializeAddButtons();
    initializeAddItemLinks();
    initializeDeleteButtons();
    initializeEditButtons();
    initializeForm();
    initializeShortcuts();

    const contentDiv = document.getElementById('content');
    if (contentDiv) {
        const scrollPos = localStorage.getItem('contentDivScrollPos');
        if (scrollPos) {
            setTimeout(function() {
                contentDiv.scrollTop = scrollPos;
                contentDiv.scrollIntoView();
            }, 0);
        }

        contentDiv.addEventListener('scroll', function() {
            console.log('Scroll position:', contentDiv.scrollTop);
            localStorage.setItem('contentDivScrollPos', contentDiv.scrollTop);
        });
    }
}

function initializeAddButtons() {
    let addButtons = document.querySelectorAll('.add-item');
    addButtons.forEach(addButton => {
        addButton.addEventListener('click', function (e) {
            e.preventDefault();
            let form = this.form;
            let url = $(form).attr('action');
            let dataType = form.getAttribute('data-type');
            let dataId = form.getAttribute('data-id');
            let formData = new FormData(form);

            if (form.querySelector('input.add-item-input').value === '') {
                return;
            }

            formData.append('_method', 'POST');
            fetch(url, {
                method: form.method,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            })
                .then(async response => {
                    const responseData = await response.json();
                    if (!responseData.id || !responseData.value) {
                        return;
                    }
                    let id = responseData.id;
                    let value = responseData.value;
                    let ul = document.getElementById(this.form.name + 'List');
                    let li = document.createElement('li');
                    li.innerHTML = value + ' <input type="button" class="delete-item" data-id="' + id + '" value="&#x2715;">';
                    ul.appendChild(li);
                    await updateChecklist(dataType, dataId);
                    updateLastUpdatedTime();
                    document.querySelector('input.add-item-input').value = '';
                });
        });
    });
}

function initializeEditButtons() {
    let editInputs = document.querySelectorAll('input[type=checkbox], .edit, input[type=radio]');
    editInputs.forEach(input => {
        ['change'].forEach(event => {
            input.addEventListener(event, async function () {
                if (!this.form) return;
                let form = this.form;
                let url = $(form).attr('action');
                let inputName = this.name;
                let dataType = form.getAttribute('data-type');
                let dataId = form.getAttribute('data-id');
                let updateElementClassName = form.getAttribute('data-update-element-class-name');

                let formData = new FormData(form);
                formData.append('_method', form.querySelector('input[name="_method"]').value);

                const errorMessageElement = getNextParentSiblingDivWithClass(this, 'invalid-feedback');

                const existingSuccessIcon = this.nextElementSibling;
                if (existingSuccessIcon && existingSuccessIcon.classList.contains('success-icon')) {
                    existingSuccessIcon.remove();
                }
                const existingFailureIcon = this.nextElementSibling;
                if (existingFailureIcon && existingFailureIcon.classList.contains('failure-icon')) {
                    existingFailureIcon.remove();
                }

                // Create and insert progress icon
                const progressIcon = document.createElement('i');
                progressIcon.classList.add('progress-icon');
                this.parentNode.insertBefore(progressIcon, this.nextSibling);

                fetch(url, {
                    method: form.method,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: formData
                })
                    .then(async response => {
                        const responseData = await response.json();
                        const statusIcon = document.createElement('i');
                        progressIcon.remove();
                        if (response.ok) {
                            if (errorMessageElement !== null) {
                                errorMessageElement.textContent = "";
                            }
                            statusIcon.classList.add('success-icon');
                            setTimeout(() => {
                                statusIcon.remove();
                            }, 2000);
                            await updateChecklist(dataType, dataId);
                            updateLastUpdatedTime();
                            if (updateElementClassName) {
                                document.querySelector(updateElementClassName).textContent = document.querySelector('input[name="' + inputName + '"]').value;
                            }
                        } else if (response.status === 422) {
                            statusIcon.classList.add('failure-icon');
                            if (responseData.errors && responseData.errors.hasOwnProperty(inputName)) {
                                if (errorMessageElement !== null) {
                                    errorMessageElement.textContent = responseData.errors[inputName];
                                }
                            }
                        } else {
                            // Handle other error response codes as needed
                            statusIcon.classList.add('failure-icon');
                            if (errorMessageElement !== null) {
                                errorMessageElement.textContent = 'Fout, probeer het nogmaals.';
                            }
                        }

                        // Create and insert status icon
                        this.parentNode.insertBefore(statusIcon, this.nextSibling);
                    })
            });
        });
    });
}

function initializeDeleteButtons() {
    document.addEventListener('click', function (e) {
            if (e.target.classList.contains('delete-item')) {
                e.preventDefault();
                let form = e.target.form;
                let url = $(form).attr('action');
                let id = e.target.dataset['id'];
                let dataType = form.getAttribute('data-type');
                let dataId = form.getAttribute('data-id');

                let formData = new FormData(form);
                formData.append('_method', form.querySelector('input[name="_method"]').value);
                formData.append('id', id);

                fetch(url, {
                    method: form.method,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: formData
                })
                    .then(async response => {
                        let parentLi = e.target.parentElement;
                        parentLi.remove();
                        await updateChecklist(dataType, dataId);
                        updateLastUpdatedTime();
                    });
            }
        }
    );
}

function initializeForm() {
    let inputs = document.querySelectorAll('.edit,.add-item-input');
    inputs.forEach((input, i) => {
        input.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                if (event.target.classList.contains('submit-immediately')) {
                    return;
                }
                event.preventDefault();
                if (event.target.className === 'form-control add-item-input') {
                    let currentElement = event.target;
                    let nextDiv = currentElement.parentElement.parentElement.parentElement.nextElementSibling;
                    if (nextDiv && nextDiv.tagName === 'DIV') {
                        let closestAddItem = nextDiv.querySelector('.add-item-link, .add-item');
                        closestAddItem.click();
                        event.target.value = "";
                    }

                } else {
                    if (i < inputs.length - 1) {
                        inputs[i + 1].focus();
                        let val = inputs[i + 1].value;
                        inputs[i + 1].value = '';
                        inputs[i + 1].value = val;


                    }
                }
            }
        });
    });

    if (inputs.length > 0) {
        inputs[0].focus();
        let val = inputs[0].value;
        inputs[0].value = '';
        inputs[0].value = val;
    }
}

function initializeShortcuts() {
    window.addEventListener('keydown', function(event) {
        if (event.ctrlKey && event.shiftKey && event.key === 'ArrowRight') {
            event.preventDefault();
            let element = document.getElementById('nextItem');
            if (element && element.href) {
                window.location.href = element.href;
            }
        }
        if (event.ctrlKey && event.shiftKey && event.key === 'ArrowLeft') {
            event.preventDefault();
            let element = document.getElementById('previousItem');
            if (element && element.href) {
                window.location.href = element.href;
            }
        }
    });
}

async function updateChecklist(type, id) {
    try {
        const url = "/admin/" + type + "/" + id + "/form-progress";
        const response = await fetch(url);
        const data = await response.json();

        for (const key in data) {
            const listItem = document.querySelector(`li[data-id="${key}"]`);
            if (listItem) {
                if (data[key]) {
                    listItem.classList.remove('gray');
                } else {
                    listItem.classList.add('gray');
                }
            }
        }
    } catch (error) {
        console.error('Error:', error);
    }
}

function updateLastUpdatedTime() {
    let date = new Date(); // get current date and time
    let options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    let formattedDate = date.toLocaleString('nl-NL', options) + " uur";
    let divElement = document.getElementById('lastUpdatedTime');
    if (divElement) {
        divElement.textContent = formattedDate;
    }
}

function getNextParentSiblingDivWithClass(element, className) {
    let sibling = element.parentElement.nextElementSibling;
    while (sibling) {
        if (sibling.tagName === 'DIV' && sibling.classList.contains(className)) {
            return sibling;
        }
        sibling = sibling.nextElementSibling;
    }
    return null;
}

function initializeAddItemLinks() {
    let addItemLinks = document.querySelectorAll('a.add-item-link');
    addItemLinks.forEach(addItemLink => {
        addItemLink.addEventListener('click', function (e) {
            e.preventDefault();
            let csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            let relatedInputId = this.getAttribute('data-related-input-id');
            let relatedSelectId = this.getAttribute('data-related-select-id');
            let refreshPage = this.getAttribute('data-refresh-page');
            let itemableType = this.getAttribute('data-itemable-type');
            let postUrl = this.getAttribute('data-post-url');
            let inputElement = document.getElementById(relatedInputId);
            let inputValue = inputElement.value;
            inputElement.value = '';

            if (inputValue === '') {
                return;
            }

            let formData = new FormData();
            formData.append("value", inputValue);
            formData.append("itemable_type", itemableType);

            fetch(postUrl, {
                method: "POST",
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (refreshPage) {
                        location.reload();
                    } else {
                        let selectElement = document.getElementById(relatedSelectId);
                        let newOption = document.createElement("option");
                        newOption.value = data.id;
                        newOption.text = data.value;
                        newOption.selected = true;
                        selectElement.appendChild(newOption);

                        // Refresh the selectpicker
                        $('.selectpicker').selectpicker('refresh');

                        // And trigger a change
                        let event = new Event('change');
                        selectElement.dispatchEvent(event);
                    }

                })
                .catch(error => {
                    // Handle the error here
                    console.error('Error:', error);
                });

        });
    })
}


// CK editors
$(document).ready(() => {
    let editors = document.querySelectorAll('.ckeditor-simple');
    let csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    let saveDataInterval = 1000;
    let saveDataTimer = [];

    for (let i = 0; i < editors.length; i++) {
        let ck = window.getCkeditorInstanceByElement($(editors[i]));

        ck.ui.focusTracker.on('change:isFocused', (evt, name, isFocused) => {
            if (!isFocused) {
                clearInterval(saveDataTimer[ck.sourceElement.name]);
            }
            if (isFocused) {
                saveDataTimer[ck.sourceElement.name] = setInterval(() => {
                    let id = $('input[name="tree_id"]').val();
                    let type = $('input[name="type"]').val();
                    let postUrl = "/admin/" + type + "/" + id + "/description/update-description";
                    let formData = new FormData();

                    formData.append("type", ck.sourceElement.name);
                    formData.append("description", ck.getData());
                    formData.append("lang", ck.sourceElement.lang);
                    formData.append('_method', "PUT");

                    fetch(postUrl, {
                        method: 'POST',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'X-CSRF-TOKEN': csrfToken
                        },
                        body: formData
                    })
                        .then(async response => {})
                        .then(data => {})
                        .catch((error) => console.error('Error:', error));
                }, saveDataInterval);
            }
        });
    }
});

$(document).on('nc.sidePanel.shown', function (e, result) {
   initializeEditButtons();
});

$(document).on('nc.sidePanel.reloaded', function (e, result) {
    initializeEditButtons();
});

$(document).on('nc.sidePanel.hide', function (e, result) {
    location.reload();
});
window.updateChecklist = updateChecklist;
